import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { setAirlineFilter } from '../../redux/currentSearch/actions';
import { getAirlineFilter, getConfig } from '../../redux/currentSearch/selectors';
import { withPageContext } from '../../utils';
import { Checkbox } from '../../components';

const AirlineFilterSelector = React.memo(({ airlineIata, airlineName }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isDisabled = !useSelector((state) => getConfig(state))?.airlineCheckbox.enabled;
    const value = useSelector((state) => getAirlineFilter(state));

    const onAirlineFilterChange = () => dispatch(
        setAirlineFilter({
            airlineName,
            airlineIata,
            enabled: !value?.enabled,
        })
    );

    const checkboxProps = {
        id: 'airline-filter-selector',
        checked: value?.enabled,
        disabled: isDisabled,
        onChange: onAirlineFilterChange,
    };

    useEffect(() => dispatch(
        setAirlineFilter({
            airlineName,
            airlineIata,
            enabled: true
        })), [airlineIata, airlineName, dispatch]);

    return (
        <React.Fragment>
            <Checkbox {...checkboxProps}>
                {t('flightsManager.airline.filter', { airlineName })}
            </Checkbox>
        </React.Fragment>
    );
});

AirlineFilterSelector.propTypes = {
    airlineName: PropTypes.string.isRequired,
    airlineIata: PropTypes.string.isRequired,
};
const AirlineFilterSelectorWithPageContext = withPageContext(AirlineFilterSelector);
export { AirlineFilterSelectorWithPageContext as AirlineFilterSelector };
